import { View } from "@react-pdf/renderer";
import React from "react";

export function Window() {
	/** Render */
	return (
		<React.Fragment>
			<View
				fixed
				style={{
					position: "absolute",
					top: "27mm",
					left: "20mm",
					width: "90mm",
					height: "45mm",
					border: "1px dashed black",
					borderRadius: "5px",
				}}
			/>
		</React.Fragment>
	);
}
